// import components
import { ControlledCheckbox } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

// import external libraries
import { useTranslation } from 'react-i18next';

const TravelCostContent = ({ control }) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenterSettings' });

  return (
    <MultiStepForm.Section title={t('postalCode.title')}>
      <ControlledCheckbox
        control={control}
        name="exclude-travelcost-calculation"
        label={t('postalCode.label')}
      />
    </MultiStepForm.Section>
  );
};

export default TravelCostContent;
